import { render } from "./GroupStandingsTable.vue?vue&type=template&id=ef5cedc2&scoped=true"
import script from "./GroupStandingsTable.vue?vue&type=script&lang=js"
export * from "./GroupStandingsTable.vue?vue&type=script&lang=js"

import "./GroupStandingsTable.vue?vue&type=style&index=0&id=ef5cedc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef5cedc2"]])

export default __exports__